module.exports = __webpack_public_path__ + "static/media/29EUNOG14.0f9852db.jpg";